"use strict";

document.addEventListener("DOMContentLoaded", function () {
  // Smooth scroll and offset fix for deeplinks
  // https://stackoverflow.com/a/51670796
  $('a[href^="#"]').on('click', function (e) {
    var id = $(this).attr('href');
    if (id == "#") {
      return;
    }
    e.preventDefault();
    $('html,body').animate({
      scrollTop: $(id).offset().top - 150
    }, 500);
  });

  //   // Get all "navbar-burger" elements
  //   var $navbarBurgers = Array.prototype.slice.call(
  //     document.querySelectorAll(".navbar-burger"),
  //     0
  //   );

  //   // Check if there are any navbar burgers
  //   if ($navbarBurgers.length > 0) {
  //     // Add a click event on each of them
  //     $navbarBurgers.forEach(function ($el) {
  //       $el.addEventListener("click", function () {
  //         // Get the target from the "data-target" attribute
  //         var target = $el.dataset.target;
  //         var $target = document.getElementById(target);

  //         // Toggle the class on both the "navbar-burger" and the "navbar-menu"
  //         //$el.classList.toggle("is-active");
  //         //$target.classList.toggle("is-active");
  //         $(".navbar-mobile-content").toggleClass("active");
  //         $(".navbar-burger").toggleClass("is-active");
  //         //make mobile menu fixed position if scroll is lowerthan navbar
  //         var navbar = $('.navbar.desktop');
  //         if (!navbar || !navbar.offset()) return;
  //         var fixmeTop = navbar.offset().top;      		// get initial position of the element
  //         var currentScroll = $(window).scrollTop();// get current position
  //           if (currentScroll >= 75) {          // apply position: fixed if you
  //             $(".navbar-mobile-content").addClass("fixed")
  //           } else {                                  // apply position: static
  //             $(".navbar-mobile-content").removeClass("fixed")
  //           }

  //       });
  //     });
  //   }

  //   $(".navbar-mobile-content ul li a").click(function () {	  
  // 	  var linkPage = $(this).next(".link-page");
  // 	  if (linkPage && !linkPage.hasClass('expanded')){
  // 		  linkPage.slideDown();
  //       linkPage.addClass("expanded");
  // 	  } else {
  //       linkPage.slideUp();
  //       linkPage.removeClass("expanded");
  //     }
  //   });

  //     $("#mobileNavMockSearchIcon").on("click", function (event) {
  //         $(this).hide();
  //         $("#mobileNavSearchIcon").show();
  //     })

  //     $(".closed-search").on("click", function (event) {    
  //     if ($(this).hasClass("closed-search")) {
  //       $(this).removeClass("closed-search");
  //       $(this).toggleClass("active");
  //     }
  //   });

  //   $(".close-mobile-search").on("click", function (event) {
  //     event.stopPropagation();
  //     var navSearch = $(this).closest(".nav-mobile-search");

  //     $(navSearch).addClass("closed-search");
  //     $(navSearch).removeClass("active");
  //   });

  //   $(".clear-input").on("click", function (event) {
  //     event.stopPropagation();
  //     $("#mobile-nav-input").val("")
  //   });

  //   $('.nav-dropdown-trigger').on('click', function(e){
  //     //close all other open dropdowns
  //     $('.dropdown').removeClass('active-menu');
  //     $('.nav-dropdown-trigger').not($(this)).removeClass('open-menu');
  //     $('.dropdown-menu').slideUp();

  //     if (e.target.className.indexOf('open-menu') != -1) {
  //       // close
  //       $(this).removeClass('open-menu');
  //       $(this).parents('.dropdown').removeClass('active-menu');
  //       $(this).parents('.dropdown').find('.dropdown-menu').slideUp();
  //     } else {
  //       // open
  //       $(this).addClass('open-menu');
  //       $(this).parents('.dropdown').addClass('active-menu');
  //       $(this).parents('.dropdown').find('.dropdown-menu').slideDown().promise().done(function() {
  //       });

  //         //center caret
  //         var textWidth = $(this).width();              
  //         var marginLeftCalc = textWidth / 2;

  //         var adjustCaretCss = '.navbar .dropdown.active-menu:after { margin-left: ' + marginLeftCalc + 'px; }';

  //         //Create style element
  //         var adjustCaretStyle = document.createElement('style');
  //         adjustCaretStyle.id = 'adjustCaret';
  //         adjustCaretStyle.type = 'text/css';
  //         adjustCaretStyle.appendChild(document.createTextNode(adjustCaretCss));

  //         var originalStyle = document.querySelector('style[id="adjustCaret"]')
  //         if (originalStyle) {            
  //             document.querySelector('body').replaceChild(adjustCaretStyle, originalStyle);
  //         } else {
  //             document.querySelector('body').appendChild(adjustCaretStyle);
  //         }

  //     }    
  //   });

  //   $('.close-trigger').on('click', function(e){
  //     $(this).parents('.dropdown').removeClass('active-menu');
  //     $(this).parents('.dropdown').find('.nav-dropdown-trigger').removeClass('open-menu');
  //     $(this).parents('.dropdown').find('.dropdown-menu').slideUp();
  //   });

  // });

  // $(document).ready(function () {
  //   var navbar = $('.navbar.desktop');
  //   if (!navbar || !navbar.offset()) return;

  //   var fixmeTop = navbar.offset().top;      		// get initial position of the element

  //   $(window).scroll(function() {                 // assign scroll event listener
  //       var currentScroll = $(window).scrollTop();// get current position
  //       if (currentScroll >= fixmeTop) {          // apply position: fixed if you
  //           navbar.addClass("fixed-bar")
  //       } else {                                  // apply position: static
  //           navbar.removeClass("fixed-bar")
  //       }
  //   });
  // });

  // $(document).ready(function () {
  //   var navbar = $('.navbar.mobile');
  //   if (!navbar || !navbar.offset()) return;       

  //   var fixmeTop = navbar.offset().top;			// get initial position of the element

  //   $(window).scroll(function() {					// assign scroll event listener
  //       var currentScroll = $(window).scrollTop();// get current position
  //       if (currentScroll >= fixmeTop) {          // apply position: fixed if you
  //           navbar.addClass("fixed-bar")
  //           $(".navbar-mobile-content").addClass("fixed")
  //       } else {                                  // apply position: static
  //           navbar.removeClass("fixed-bar")
  //           $(".navbar-mobile-content").removeClass("fixed")
  //       }
  //   });
});